import React from "react";
// Never a blank table — pair what's missing with how to fix it (DESIGN.md §10).
export function EmptyState({ icon, title, hint, action, className }) {
    return (<div className={`flex flex-col items-center justify-center px-6 py-10 text-center ${className ?? ""}`}>
            {icon && (<div aria-hidden={"true"} className={"mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-sunken text-gray-400 [&>svg]:h-6 [&>svg]:w-6"}>
                    {icon}
                </div>)}
            <p className={"text-sm font-medium text-gray-700"}>{title}</p>
            {hint && <p className={"mt-1 max-w-sm text-sm text-gray-500"}>{hint}</p>}
            {action && <div className={"mt-4"}>{action}</div>}
        </div>);
}
export default EmptyState;
//# sourceMappingURL=emptyState.jsx.map